import type { StaticTranslationString } from '@/types/types';

/** The heading of the app's features, in the menu drawer and in the desktop's top menu. */
export const appFeaturesTitle: StaticTranslationString = {
  en: 'App Features',
  de: 'App Funktionen',
  fr: "Fonctions de l'application",
};
